import { Button, FormItem, Input, ModalCard, Slider } from '@vkontakte/vkui';
import { Modals } from '../Consts';
import { useAppContext } from '../AppContext';
import React, { useState } from 'react';

const CURRENT_MODAL= Modals.BUY_EVENTS_MODAL;
export const BuyEventsModal = () => {
  const context = useAppContext();
  const DEFAULT_VALUE = 5;

  const [isSendData, setIsSendData] = useState(false);
  const [valueBasic, setValueBasic] = useState(DEFAULT_VALUE);

  const send = () => {
    setIsSendData(true);

    context.getBridge().bridge.send('VKWebAppShowOrderBox', {
        type: 'item',
        item: 'events_' + valueBasic,
      })
      .then((data) => {
        if (data.success) {
          setIsSendData(false);
          setValueBasic(DEFAULT_VALUE);
          context.store.setRemainingEventsCount(context.store.remainingEventsCount + Number(valueBasic));
          context.router.back();
        }
      })
      .catch((e) => {
        setIsSendData(false);
      });
  }

  const onChange = (e) => {
    if (Number(e.target.value) > 400) {
      setValueBasic(400);
    } else if (Number(e.target.value) >= 0) {
      setValueBasic(Number(e.target.value))
    }
  }

  return (
    <ModalCard
      id={CURRENT_MODAL}
      onClose={() => context.back()}
      header={context.lang().getKey(CURRENT_MODAL, 'header')}
    >
      {context.snackbar}
      <FormItem top={context.lang().getKey(CURRENT_MODAL, 'values_header')}>
        <Slider value={Number(valueBasic)} step={1} min={1} aria-labelledby="basic" onChange={(value) => setValueBasic(Number(value))} />
      </FormItem>
      <FormItem
        bottom={context.lang().getKey(CURRENT_MODAL, 'values_comment')}
      >
        <Input
          inputMode="decimal"
          className={'AmountInput'}
          placeholder={'0'}
          pattern={'\\d+'}
          value={Number(valueBasic) > 0 ? String(valueBasic) : ''}
          onKeyPress={(event) => {
            if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(event.key)) {
              event.preventDefault();
            }
          }}
          onChange={onChange}
        />
      </FormItem>
      <FormItem>
        <Button
          size="l"
          stretched
          disabled={isSendData || valueBasic < 1}
          onClick={send}
        >
          {context.lang().getKey(CURRENT_MODAL, 'button_buy_label')}
        </Button>
      </FormItem>
    </ModalCard>
  );
}